import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { eligibility } from "constants/eligibility";
import { handleOpenPdf } from "utils";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import profitrate from "assets/pdf/deposits/Board Profit Rate 080723.pdf";
import pds from "assets/pdf/deposits/TD-i PDS V2_2019.pdf";
import outline_check from "assets/images/outline_check.svg";
import fees4 from "assets/images/fees_table_4.svg";

function Commodity4() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Deposits"
          title={`Commodity Murabahah<br>
              <span className="jumbotron-subtitle-2">
                Term Deposit-<em>i</em>
              </span>`}
          buttonText="Apply Now"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              If you have cash to spare, or a long-term fixed goal in mind,
              consider alrajhi bank Malaysia's Term Deposit-<i>i</i>. It's a
              safe method of growing your wealth, as the savings period and
              profit rate is agreed upfront. By not touching your savings during
              this fixed period, you will be letting your money work harder for
              you. Rest assured, we only invest in Shariah-approved investment
              activities, the performance of which will be calculated on a
              monthly basis. It's a beautiful union between prudence and
              adventure. A good, clean Shariah-compliant way to make the most of
              your wealth.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Guaranteed</div>
                <div className="column-subheader">
                  Principal and fixed profit
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Profit</div>
                <div className="column-subheader">
                  Accrued daily and credited at maturity
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial Placement</div>
                <div className="column-subheader">
                  {"<"} 3 months = RM1,000; <b>OR</b> {">"} 3 months = RM500
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah Contract</div>
                <div className="column-subheader">
                  Commodity Murabahah (Cost + Profit)<br></br>
                  <br></br>Wakalah bil ujrah (Agency with Fee)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Deposits</div>
                <div className="column-subheader-2">
                  Make as many deposits <b>as you like</b>{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Tenure</div>
                <div className="column-subheader-2">
                  <b>Acceptable tenure from 1 month</b> to 60 months{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah standards</div>
                <div className="column-subheader-2">
                  Compliance with <b>alrajhi bank Malaysia Shariah standards</b>{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Minimum Deposit</div>
                <div className="column-subheader-2">
                  <b>Enjoy a minimum</b> deposit of RM500{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Protected by PIDM</div>
                <div className="column-subheader-2">
                  Up to <b>RM250,000</b> for each depositor
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Profit Rates</div>
                <div className="column-subheader-2">
                  Earn additional <b>0.20%</b> on top of the existing board
                  profit rates for placement through alrajhi24seven for
                  1,3,6,9,12 & 24 month(s){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitycommodityTD.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={fees4}
              className="d-inline-block align-top"
              alt=""
            />
            <p>
              * The customer will pay to alrajhi bank Malaysia Nominee
              (Tempatan) Sdn. Bhd as its agent as stated in the Terms &
              Conditions. 
            </p>
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>{" "}
              <Link to="/e-application-form" className="w-full">
                <LinkButton text="e-Application Form" />
              </Link>
              <LinkButton
                text="Profit Rates"
                onClick={() => handleOpenPdf(profitrate)}
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pds)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect!</h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Commodity4;
